import React from 'react';
import { useAudioPlayer } from '../../state';
import TrackInfoLink from './TrackInfoLink';

export interface TrackSubtitleProps {}

const TrackSubtitle: React.FC<TrackSubtitleProps> = () => {
  const { subtitle } = useAudioPlayer();

  return <TrackInfoLink data={subtitle} variant="secondary" />;
};

export default TrackSubtitle;
